import { Establishment as EstablishmentDto } from "src/app/proxy/establishments";

export class Establishment {
  locationId: number;
  name: string;
  regionId: number;
  zoneId: number;

  constructor(dto: EstablishmentDto) {
    Object.assign(this, dto);
  }
}